import React from 'react';
import * as Ink from '@carta/ink';

const types = {
  sunset: { variant: 'feedback-notice' },
  beta: { type: 'purple' },
  deprecated: { variant: 'feedback-negative' },
  external: { type: 'orange' },
} as const;

export type Status = keyof typeof types;

const statusLabels = {
  sunset: 'Sunset',
  beta: 'Preview',
  deprecated: 'Deprecated',
  external: 'External',
} as const;

const statusDescription = {
  sunset: 'This component will be deprecated soon. Consider its replacement.',
  beta: 'This component is new and may lack features. Use with thorough testing.',
  deprecated: 'Do not use deprecated components',
  external: `This component is owned by Ink but isn't implemented in the Ink repository`,
} as const;

const StatusBubble = ({ status }: { status: Status }) => {
  if (!status) return null;

  return (
    <Ink.Tooltip trigger={<Ink.Bubble {...types[status]}>{statusLabels[status]}</Ink.Bubble>} placement="bottom">
      {statusDescription[status]}
    </Ink.Tooltip>
  );
};

export default StatusBubble;
